"use client";

import ProfileCompletion from "@/features/settings/v2/ProfileCompletion";
import { useProfile } from "@/features/profile/hooks/useProfile";
import "./artist-profile.css";

/**
 * The owner's own profile page: what is left to make the account whole, each step a link to that spot in the
 * settings (`#do-<step>`). Read live from `/auth/profile` (the same query the settings save refreshes), so it ticks
 * and leaves without a reload. Mounted only for the owner; renders nothing until the profile is in, or once complete.
 */
export default function OwnerCompletion({ lang }: { lang: "fa" | "en" }) {
  const { data } = useProfile();
  // Its own room under the hero (the «edit profile» button sits just above); nothing at all once complete.
  return (
    <div className="ap-completion">
      <ProfileCompletion lang={lang} user={data?.data?.user} hrefFor={(step) => `/${lang}/settings#do-${step}`} />
    </div>
  );
}
